"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AdjustSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.0853529,5 C10.2912711,4.41740381 10.8468906,4 11.5,4 C12.1531094,4 12.7087289,4.41740381 12.9146471,5 L15,5 L15,6 L12.9146471,6 C12.7087289,6.58259619 12.1531094,7 11.5,7 C10.8468906,7 10.2912711,6.58259619 10.0853529,6 C9.60044269,6 9.23676007,6 8.99430499,6 C7.66223721,6 5.66413555,6 3,6 L3,5 C5.66106158,5 7.65685777,5 8.98738856,5 M11,5 L11,6 L12,6 L12,5 L11,5 Z M11.5,12 C12.1531094,12 12.7087289,12.4174038 12.9146471,13 L15,13 L15,14 L12.9146471,14 C12.7087289,14.5825962 12.1531094,15 11.5,15 C10.8468906,15 10.2912711,14.5825962 10.0853529,14 L3,14 L3,13 L10.0853529,13 C10.2912711,12.4174038 10.8468906,12 11.5,12 Z M11,13 L11,14 L12,14 L12,13 L11,13 Z M15,9 L15,10 L7.91464715,10 C7.70872894,10.5825962 7.15310941,11 6.5,11 C5.84689059,11 5.29127106,10.5825962 5.08535285,10 L3,10 L3,9 L5.08535285,9 C5.29127106,8.41740381 5.84689059,8 6.5,8 C7.15310941,8 7.70872894,8.41740381 7.91464715,9 L15,9 Z M6,9 L6,10 L7,10 L7,9 L6,9 Z" })));
};
AdjustSmall.displayName = 'AdjustSmall';
exports.default = AdjustSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AdjustSmall.js.map